import React from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { GOOGLE_MAPS_DEFAULT_ZOOM_FOCUSED, GOOGLE_MAPS_ID } from '../../../util/google.constants';

export interface ListingMapProps {
  lat: number;
  lng: number;
  mapTypeId?: google.maps.MapTypeId;
  mapId?: string;
  streetViewControl?: boolean;
  fullScreenControl?: boolean;
  rotateControl?: boolean;
  tilt?: number;
  zoomLevel?: number;
  minZoom?: number;
  maxZoom?: number;
  scrollwheel?: boolean;
}

export const ListingMap: React.FC<ListingMapProps> = (props: ListingMapProps) => {

  return (
    <GoogleMap
      id={props.mapId ? props.mapId : GOOGLE_MAPS_ID}
      mapContainerStyle={{ minHeight: '15em', maxHeight: '20em', width: '100%' }}
      zoom={props.zoomLevel ? props.zoomLevel : GOOGLE_MAPS_DEFAULT_ZOOM_FOCUSED}
      center={{
        lat: props.lat,
        lng: props.lng
      }}
      options={{
        tilt: props.tilt,
        streetViewControl: props.streetViewControl ? true : false,
        streetViewControlOptions: {
          position: google.maps.ControlPosition.LEFT_TOP,
        },
        scaleControl: false,
        fullscreenControl: props.fullScreenControl ? true : false,
        scrollwheel: props.scrollwheel ? true : false,
        gestureHandling: "greedy",
        disableDoubleClickZoom: true,
        minZoom: props.minZoom ? props.minZoom : 14,
        maxZoom:  props.maxZoom ? props.maxZoom : 20,
        mapTypeControl: false,
        mapTypeId: props.mapTypeId ? props.mapTypeId : google.maps.MapTypeId.ROADMAP,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.BOTTOM_CENTER,
          mapTypeIds: [
            google.maps.MapTypeId.ROADMAP,
            google.maps.MapTypeId.SATELLITE,
            google.maps.MapTypeId.HYBRID
          ]
        },
        zoomControl: true,
        rotateControl: props.rotateControl ? true : false,
        clickableIcons: true
      }}
    >
      {(props.lat !== null && props.lat !== 0) &&
        <Marker
          position={{
            lat: props.lat,
            lng: props.lng
          }}
          clickable={false}
        />
      }
    </GoogleMap>
  );
}
